import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'PrimaryButton',
  props: {
  text: String,
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;



const handleClick = (e) => {
  emit("click", e);
};



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    onClick: handleClick,
    type: "submit",
    class: "btn-primary px-4 py-2 text-white w-[200px]",
    label: props.text
  }, null, 8, ["label"]))
}
}

})